import React from "react";
import RegistrationSvgIcon from "./RegistrationSvgIcon";

export default function UserProfileIcon({ size = 24 }) {
  const UserProfileIconSVG = `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.1 10.37C12 10.36 11.88 10.36 11.77 10.37C9.39 10.29 7.5 8.34 7.5 5.94C7.5 3.54 9.48 1.5 11.94 1.5C14.4 1.5 16.38 3.49 16.38 5.94C16.37 8.34 14.48 10.29 12.1 10.37Z" stroke="black" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M5.75914 14.9305C2.73914 16.6205 2.73914 19.3805 5.75914 21.0605C9.18914 22.9805 14.8091 22.9805 18.2391 21.0605C21.2591 19.3705 21.2591 16.6105 18.2391 14.9305C14.8291 13.0205 9.19914 13.0205 5.75914 14.9305Z" stroke="black" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
`;
  return (
    <RegistrationSvgIcon xml={UserProfileIconSVG} width={size} height={size} />
  );
}
